import { useModalCalendarContext } from "./ListingModalCalendarProvider";
import { AppTextButton } from "../../../../global/ui/buttons";
import { scheduleWorkout } from "../../../../../api/listings";
import { ErrorSnackbar } from "../../../../global/snackbar";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import useUser from "../../../../../hooks/user/useUser";
import { useSnackbarContext } from "../../../../global/snackbar/SnackbarProvider";
import { useModalContext } from "../../../../global/modals/ModalProvider";
import { WorkoutSuccessScheduleModal } from "./workoutSuccessScheduleModal/WorkoutSuccessScheduleModal";

export const ListingModalCalendarScheduleBtn = () => {
  const listingData = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const { user } = useUser();
  const { setSnackbar } = useSnackbarContext();
  const { state, dispatch } = useModalCalendarContext();
  const { showModal } = useModalContext();

  async function handleSchedule() {
    const scheduleData = {
      athleteId: user.id,
      trainingPlanId: listingData.trainingPlanId,
      swapFutureExercises: false,
      startDate: state.dateValue.toISOString(),
      type: "workout",
      removeFutureSchedules: false,
      title: listingData.trainingPlan.title,
      trainingSchedule: listingData.trainingPlan.defaultSchedule,
      fromPaidTrainingPlan: false,
    };

    try {
      dispatch({ isLoading: true });
      await scheduleWorkout(user, scheduleData);
      showModal(<WorkoutSuccessScheduleModal />);
    } catch (e) {
      const error = e as Error;
      setSnackbar(<ErrorSnackbar message={error} />);
    } finally {
      dispatch({ isLoading: false });
    }
  }

  return (
    <AppTextButton
      onClick={() => {
        void handleSchedule();
      }}
      disabled={state.isLoading || state.invalidDate}
    >
      Schedule Workout
    </AppTextButton>
  );
};
